'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './dynamic-page.routes';

export class DynamicPageComponent {
  constructor($stateParams, DynamicPageService) {
    'ngInject';

    this.pageName = $stateParams.name;
    this.pageParam = $stateParams.param;

    var METHOD = this.public ? "getPublicByName" : "getByName";

    DynamicPageService[METHOD]({name: this.pageName}, page => {
      this.html = this.convertShortcode(page.data);
    }, err => {
      this.pageNotFound = true;
    });
  }

  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }
}

export default angular.module('conduu.dynamicPage', [uiRouter])
  .config(routes)
  .component('dynamicPage', {
    template: require('./dynamic-page.html'),
    controller: DynamicPageComponent,
    controllerAs: 'ctrl',
    bindings: {
        public: '<'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/dynamic-page/dynamic-page.component.js